export default {"src":"/_next/static/media/warranty.b315b3b4.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};